module.exports = __webpack_public_path__ + "img/download-app.8d7cb104.svg";